import {forOwn, get, has, merge,omitBy} from "lodash";
import {dateIntervalView,elDateTimePickerMinMaxControl,simpleValueView, arrayListView,checkBoxControl,dropdownHttpControl,inputControl,selectControl} from "./compLayouts"
import {checkOnLoadHyperSchema} from "@/utils/jsonSchemeUtils"
import jsonPointer from '@/utils/jsonPointer'

export const dateIntervalColumn = (modelPath,minDatePath,maxDatePath,minDateProp,maxDateProp)=>{
  return {
    title:minDateProp.title+(maxDateProp.title?("-"+maxDateProp.title):''),
    layout2:dateIntervalView(modelPath,minDatePath,maxDatePath,minDateProp.format=="date-time"?"DD.MM.YYYY HH:mm:ss":"DD.MM.YYYY"),
  }
};

export const dateIntervalEditableColumn = (modelPath,minDatePath,maxDatePath,minDateProp,maxDateProp,axiosParams)=>{
  return {
    title:minDateProp.title+(maxDateProp.title?("-"+maxDateProp.title):''),
    layout2:{
      "component":"div",
      "data":{
        "editing":false,
        "axiosParams":axiosParams,
      },
      "children":[
        merge(
          dateIntervalView(modelPath,minDatePath,maxDatePath,minDateProp.format=="date-time"?"DD.MM.YYYY HH:mm:ss":"DD.MM.YYYY"),
          {
            "vIf":"{!vue.data.editing}",
            "params":{
              "on":{
                "click":"{function(e){vue.data.editing=true}}"
              }
            }
          }
        ),
        merge(
          elDateTimePickerMinMaxControl(modelPath,minDatePath,maxDatePath,minDateProp,maxDateProp),
          {
            "vIf":"{vue.data.editing}",
            "params":{
              "on":{
                //TODO преобразовать nestedPath to Object
                "input":"{function(e){vue.data.editing=false;vue.$axiosHelper(vue.data.axiosParams,{data:{id:vue."+modelPath+".id,"+minDatePath+":e[0],"+maxDatePath+":e[1]}},vue."+modelPath+")}}"
              }
            }

          }
        ),

      ]
    }
  }
};

export const dateIntervalControlColumn = (modelPath,minDatePath,maxDatePath,minDateProp,maxDateProp)=>{
  return {
    title:minDateProp.title+(maxDateProp.title?("-"+maxDateProp.title):''),
    layout2:elDateTimePickerMinMaxControl(modelPath,minDatePath,maxDatePath,minDateProp,maxDateProp)
  }
};

export const checkBoxEditableColumn = (modelPath,propPath,prop,axiosParams,options)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": prop.sortable,
    "layout2": merge(
      checkBoxControl(modelPath,propPath,prop,merge(options,{hideLabel:true})),
      {
        "data":{
          "axiosParams":axiosParams,
        },
        "params":{
          "on":{
             "input":"{function(e){vue.$axiosHelper(vue.data.axiosParams,{data:{id:vue."+modelPath+".id,"+propPath+":e}},vue."+modelPath+")}}"
          }
        }
      })
  }
};

export const inputControlColumn = (modelPath,propPath,prop,options)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": prop.sortable,
    "layout2": inputControl(modelPath,propPath,prop,options)
  }
};

export const simpleValueColumn = (modelPath,propPath,prop)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": prop.sortable,
    "layout2": simpleValueView(modelPath,propPath,undefined,undefined,prop.expression,prop.expressionFormat)
  }
};

export const arrayListColumn = (modelPath,propPath,prop)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": false,
    "layout2": arrayListView(modelPath,propPath,prop)
  }
};

export const selectColumn = (modelPath,propPath,prop)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": false,
    "layout2": selectControl(modelPath,propPath,prop)
  }
};

export const httpSchemaColumn = (modelPath,propPath,prop,isMulti,hideSearch)=>{
  return {
    "title": prop.title,
    "path": propPath,
    "sortable": false,
    "layout2": dropdownHttpControl(modelPath,propPath,prop.httpSchemas,isMulti,hideSearch)
  }
};

export const solveRefIfNeed = (prop, globalSchema) => {
  if (prop.$ref) {
    const title = prop.title;//Сохраняем исходный title
    prop = jsonPointer.get(globalSchema, prop.$ref);
    if (title) prop.title = title;
  }
  return prop;
};

export const textAreaColumn=(path, prop, modelPath)=>{
  return {
    "title": prop.title,
    "path": path,
    "sortable": prop.sortable,
    "layout2": textAreaControl(path, prop, modelPath)
  }
};

export const textAreaControl = (path, prop, modelPath) => {
  return {
    "component": "text-area-control",
    "params": {
      "props": {
        "options": {},
        "property": prop,
        "value": "{vue.$lodash.get(vue." + modelPath + ",'" + path + "')}"
      },
      "on": {
        "input": "{function(e){Vue.$nestedSet(vue." + modelPath + ", '" + path + "', e)}}"
      },
    }
  }
};

export const columnsByProperties = (properties,userOptions={})=>{
  const defaultOptions={
    labelIsFirstColumn:true,
    labelPath:"label",
    axiosParams:{},
    forEditable:false,
    modelPath:"externalData.rowData",
    hyperSchema:null
  };

  const options = merge(defaultOptions,userOptions);
  let columns=[];
  forOwn(properties,(prop,propName)=>{
    prop = solveRefIfNeed(prop,options.hyperSchema);
    if(has(prop,'maximum.$data')){
      const maxPropName = prop.maximum.$data.substring("1/".length);
      if (get(properties,maxPropName+'.minimum.$data').substring("1/".length)==propName){
        if (prop.type=="integer"&&(prop.format=="date-time"||prop.format=="date")) {
          const maxProp=properties[maxPropName];
          if (options.forEditable){
            columns.push(dateIntervalControlColumn(options.modelPath,propName,maxPropName,prop,maxProp));
          }else{
            if (prop.readOnly||maxProp.readOnly){
              columns.push(dateIntervalColumn(options.modelPath,propName,maxPropName,prop,maxProp));
            }else{
              columns.push(dateIntervalEditableColumn(options.modelPath,propName,maxPropName,prop,maxProp,options.axiosParams));
            }

          }

          return;
        }
      }
    }
    if(has(prop,'minimum.$data')) return; //исключаем из списка свойства с максимальным значением

    if (prop.type=="array"){
      columns.push(arrayListColumn(options.modelPath,propName,prop));
      return
    }

    if (prop.type=="boolean"){
      columns.push(checkBoxEditableColumn(options.modelPath,propName,prop,options.axiosParams));
      return
    }

    if (options.forEditable && prop.type == "string" && prop.enum ) {
      columns.push(selectColumn(options.modelPath,propName,prop));
      return
    }

    if(options.forEditable && prop.type == "string" && prop.maxLength){
      columns.push(textAreaColumn(propName, prop, options.modelPath));
      return
    }

    if (options.forEditable && (prop.type == "integer" || prop.type == "number" || prop.type == "string" ) ) {
      columns.push(inputControlColumn(options.modelPath,propName,prop));
      return
    }

    if (prop.httpSchemas) {
      columns.push(httpSchemaColumn(options.modelPath,propName,prop));
      return
    }

    columns.push(simpleValueColumn(options.modelPath,propName,prop))
  });

  columns = columns.filter(e=>e);//отсеиваем все для которых не нашли controls

  if (options.labelIsFirstColumn){
    const labelColumn = columns.filter(col=>col.path==options.labelPath)||[];
    columns = labelColumn.concat(columns.filter(col=>col.path!=options.labelPath));
  }

  return columns
};

export const columnsBySchemaPromise = (schemaURL,userOptions)=>{
  return checkOnLoadHyperSchema(schemaURL).then(schema=>columnsByProperties(omitBy(schema.properties,prop=>prop.format=="special"),userOptions))
};
